
import React, { PureComponent } from 'react';
import moment from 'moment'
import { Form, Button, Input, DatePicker, message, Select, Table, Menu, Dropdown, Tag } from 'antd';
import { Tabs } from 'antd';
import { callPatient, editExamRoom, editStayAppointmentList, stayAppointmentQuery, appointmentQuery, registerQuery, calllQuery, examRoomList, initHospitalDepts, initExamRoomList, getPatientSourceList } from '@/request/api'

const { Option } = Select;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;
const { SubMenu } = Menu;

const dateFormat = 'YYYY-MM-DD'; // 默认当前时间
let tab1Column = []

let tab2Column = [
  {
    title: '病历号',
    dataIndex: 'PATIENT_ID',
    key: 'PATIENT_ID',
    align: 'center',
    width: '120px',
  },
  {
    title: '姓名',
    dataIndex: 'NAME',
    key: 'NAME',
    align: 'center',
    width: '100px'
  },
  {
    title: '性别',
    dataIndex: 'SEX',
    key: 'SEX',
    align: 'center',
    width: '80px',
  },
  {
    title: '年龄',
    dataIndex: 'EXAM_AGE',
    key: 'EXAM_AGE',
    align: 'center',
    width: '80px',
  },
  {
    title: '出生日期',
    dataIndex: 'BIRTHDAY',
    key: 'BIRTHDAY',
    align: 'center',
    render: date => <span>{moment(date ? date : undefined).format('YYYY-MM-DD')}</span>,
  },
  {
    title: '门诊号',
    dataIndex: 'OUTP_NO',
    key: 'OUTP_NO',
    align: 'center',
  },
  {
    title: '住院号',
    dataIndex: 'INP_NO',
    key: 'INP_NO',
    align: 'center',
  },
  {
    title: '医保性质',
    dataIndex: 'INSURANCE_TYPE',
    key: 'INSURANCE_TYPE',
    align: 'center',
  },
  {
    title: '电话',
    dataIndex: 'CONTACT_TEL',
    key: 'CONTACT_TEL',
    align: 'center',
  },
  {
    title: '优先级别',
    dataIndex: 'CROWD_TYPE',
    key: 'CROWD_TYPE',
    align: 'center',
    render: exam => <span>{exam === '0' ? '普通人' :
      (exam === '1' ? '军人' :
        (exam === '2' ? 'VIP' : ''))}
    </span>
  },
];

let tab3Column = [
  {
    title: '检查号',
    dataIndex: 'EXAM_NO',
    key: 'EXAM_NO',
    align: 'center'
  },
  {
    title: '姓名',
    dataIndex: 'NAME',
    key: 'NAME',
    align: 'center',
    width: '100px'
  },
  {
    title: '性别',
    dataIndex: 'SEX',
    key: 'SEX',
    align: 'center',
    width: '80px',
  },
  {
    title: '年龄',
    dataIndex: 'EXAM_AGE',
    key: 'EXAM_AGE',
    align: 'center',
    width: '80px',
  },
  {
    title: '出生日期',
    dataIndex: 'BIRTHDAY',
    key: 'BIRTHDAY',
    align: 'center',
    render: date => <span>{moment(date ? date : undefined).format('YYYY-MM-DD')}</span>,
  },
  {
    title: '预约检查日期',
    dataIndex: 'APPOINTMENT_TIME',
    key: 'APPOINTMENT_TIME',
    align: 'center',
    render: val => <span>{moment(val ? val : undefined).format('YYYY-MM-DD HH:mm:ss')}</span>,
  },
  {
    title: '来源',
    dataIndex: 'PATIENT_SOURCE_NAME',
    key: 'PATIENT_SOURCE_NAME',
    align: 'center'
  },
  {
    title: '优先级别',
    dataIndex: 'CROWD_TYPE',
    key: 'CROWD_TYPE',
    align: 'center',
    render: exam => <span>{exam === '0' ? '普通人' :
      (exam === '1' ? '军人' :
        (exam === '2' ? 'VIP' : ''))}
    </span>
  },
];

let tab4Column = [
  {
    title: '姓名',
    dataIndex: 'NAME',
    key: 'NAME',
    align: 'center',
    width: '100px'
  },
  {
    title: '性别',
    dataIndex: 'SEX',
    key: 'SEX',
    align: 'center',
    width: '80px',
  },
  {
    title: '年龄',
    dataIndex: 'EXAM_AGE',
    key: 'EXAM_AGE',
    align: 'center',
    width: '80px',
  },
  {
    title: '检查项目',
    dataIndex: 'ITEM_NAME',
    key: 'ITEM_NAME',
    align: 'center',
  },
  {
    title: '检查房间',
    dataIndex: 'EXAM_ROOM',
    key: 'EXAM_ROOM',
    align: 'center',
  },

  {
    title: '来源',
    dataIndex: 'PATIENT_SOURCE_NAME',
    key: 'PATIENT_SOURCE_NAME',
    align: 'center',
  },
  {
    title: '优先级别',
    dataIndex: 'CROWD_TYPE',
    key: 'CROWD_TYPE',
    align: 'center',
    render: exam => <span>{exam === '0' ? '普通人' :
      (exam === '1' ? '军人' :
        (exam === '2' ? 'VIP' : ''))}
    </span>
  },
  {
    title: '检查登记日期',
    dataIndex: 'REGISTRATION_TIME',
    key: 'REGISTRATION_TIME',
    align: 'center',
    render: val => <span>{moment(val ? val : undefined).format('YYYY-MM-DD HH:mm:ss')}</span>,
  },
];

class Classify extends PureComponent {
  columns = []
  constructor(props) {
    super(props)
    this.state = {
      tab1Data: [], // 申请
      tab2Data: [], // 待预约
      tab3Data: [], // 预约
      tab4Data: [], // 登记
      arrgData: [], // 排号
      arr: [], // 登记、排号检查房间
      sourceType: [],    //患者来源
      departmentList: [],//检查科室
      hospitalRoomList: [], //检查房间
      status: 3,
      queryBtn: true,
      params: {
        pageNo: 1,
        pageSize: 10,
        NAME: ""
      }
    }
  }

  componentDidMount() {
    this.props.onRef(this)
    this.getPatientSourceData()//患者来源
    this.initHospitalDept() // 检查科室
    this.handleRoomGrop()//检查房间
  }

  setColumns = (data) => {
    const columns = []
    data.forEach((item) => {
      let key = item[0].EXAM_ROOM
      if (key && typeof key === 'string') {
        columns.push({
          title: key,
          dataIndex: key,
          key: key,
          align: 'center',
          render: (tags) => {
            let color = tags && tags.CALLOK === 0 ? 'blue' : tags && tags.CALLOK === 1 ? 'orange' : tags && tags.CALLOK === 2 ? 'red' : ''
            if (tags && tags.NAME !== null) {
              return <Dropdown overlay={() => this.menu(tags)} trigger={['contextMenu']}>
                <Tag color={color} style={{ fontSize: '18px', height: '32px', lineHeight: '32px' }}>
                  {tags.NAME}
                </Tag>
              </Dropdown>
            }
          }
        })
      }
    })
    return columns
  }

  setData = (data) => {
    const _data = []
    data.forEach((item) => {
      const key = item[0].EXAM_ROOM
      item.forEach((items, index) => {
        const len = _data.length - 1
        if (len < index) {
          const obj = {
            [key]: items
          }
          _data.push(obj)
        } else {
          _data[index][key] = items
        }
      })
    })
    return _data
  }

  menu = (tags) => {
    let arr = JSON.parse(localStorage.getItem('roomList'))
    return <Menu>
      <Menu.Item onClick={() => this.handleClickCall(tags)}>呼叫患者</Menu.Item>
      <SubMenu title="切换检查房间">
        {arr.map((item, index) => {
          return <Menu.Item key={index} onClick={() => this.handleClickRoom(tags, item)}>{item.ROOM_NAME}</Menu.Item>
        })}
      </SubMenu>
    </Menu>
  }

  handleClickCall = (tags) => {   // 右键呼叫患者
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    if (tags.NAME) {
      let params = {
        Type: "CallPatient",
        HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
        EXAM_UID: tags.EXAM_UID
      }
      callPatient(params).then((res) => {
        if (res && res.Status === 1) {
          message.success("呼叫成功!")
          this.changeAttrQuery()
        } else {
          message.error("呼叫失败!")
        }
      });
    }
  }

  handleClickRoom = (tags, item) => { // 切换检查房间
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    if (tags.EXAM_ROOM !== item.ROOM_NAME) {
      let params = {
        Type: "EDITEXAM_ROOM", //右键切换科室
        HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
        EXAM_ROOM: item.ROOM_NAME,
        EXAM_UID: tags.EXAM_UID
      }
      editExamRoom(params).then((res) => {
        if (res && res.Status === 1) {
          message.success("检查房间切换成功!")
          this.changeAttrQuery()
        } else {
          message.error("检查房间切换失败!")
        }
      });
    } else {
      message.error("不能切换当前检查房间！")
    }
  }

  apptTableRow = (record, type) => {  // 双击一行-编辑 待预约列表
    this.props.setAddSubmit(this.state.status)
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    let params = {
      Type: "WaitAppointmentDataByid", // 待预约列表
      HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
      EXAM_UID: record.EXAM_UID,
      EXAM_STATUS: type
    }
    editStayAppointmentList(params).then((res) => {
      if (res && res.Status === 1) {
        this.props.data(res.Result)
      }
    });
  }

  changeApptQuery = () => {  // 待预约列表查询
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let params = {
          "Type": "WaitAppointmentQuery",           // 待预约查询列表 
          "HOSPITAL_CODE": userInfo.HOSPITAL_CODE,
          ...values
        }
        stayAppointmentQuery(params).then((res) => {
          if (res && res.Status === 1) {
            const data = res.Result;
            this.setState({
              tab2Data: data,
            })
          }
        });
      }
    })
  }

  handleAppoQuery = () => {  // 预约列表查询
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    this.props.form.validateFields((err, values) => {
      let hospitalDateTime = values.hospDate && values.hospDate.map((item) => moment(item).format("YYYY-MM-DD"))
      if (!err) {
        let params = {
          Type: "APPOINTMENTQuery", // 预约查询列表 
          HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
          NAME: values.NAME || "",
          FIRST_SPELL: values.FIRST_SPELL || "", // 首拼
          PATIENT_SOURCE: values.PATIENT_SOURCE || "", // 来源
          EXAM_ROOM: values.EXAM_ROOM || "", // 检查房间
          EXAM_DEPT_NAME: this.state.examDeptName || "", // 检查科室
          hospitalDateTime: hospitalDateTime || "",
        }
        appointmentQuery(params).then((res) => {
          if (res && res.Status === 1) {
            const data = res.Result;
            this.setState({
              tab3Data: data,
            })
          }
        });
      }
    })
  }

  handleRegQuery = (e) => {  // 登记查询列表
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    this.props.form.validateFields((err, values) => {
      let firstDate = values.firstDate && values.firstDate.map((item) => moment(item).format("YYYY-MM-DD"));
      if (!err) {
        let params = {
          Type: "REGISTERQuery", // 预约查询列表 
          HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
          EXAM_ROOM: values.check_room || '', // 检查房间
          PATIENT_SOURCE: values.source || '', // 来源
          PATIENT_ID: values.id || '', // ID号
          INP_NO: values.check_num || '', // 检查号
          OUTP_NO: values.outp || '', // 门诊号
          hospitalDateTime: firstDate || "",
        }
        registerQuery(params).then((res) => {
          if (res && res.Status === 1) {
            const data = res.Result;
            this.setState({
              tab4Data: data,
            })
          }
        });
      }
    })
  }

  changeAttrQuery = (e) => {  // 排队列表查询
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    this.props.form.validateFields((err, values) => {
      const date = values.date && values.date.format('YYYY-MM-DD')
      if (!err) {
        let params = {
          Type: "CALLQuery",
          HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
          EXAM_ROOM: values.grouping || '',
          DATE: date || '',
          NAME: values.name || ''
        }
        calllQuery(params).then((res) => {
          if (res && res.Status === 1) {
            let data = res.Result
            this.columns = this.setColumns(data)
            this.setState({
              arrgData: this.setData(data),
            })
          }
        });
      }
    })
  }

  disabledDate(current) {
    return current > moment().subtract(0, 'day')
  }

  handleActiveKey = (key) => {
    switch (key) {
      case "2":
        this.changeApptQuery()
        break;
      case "3":
        this.handleAppoQuery()
        break;
      case "4":
        this.handleRegQuery()
        break;
      case "5":
        this.changeAttrQuery()
        break;
      default:
        break;
    }
  }

  handleRoomGrop = () => {  // 检查房间列表
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    let params = {
      Type: "ExamData",
      hospital_uid: userInfo.HOSPITAL_UID,
    }
    examRoomList(params).then((res) => {
      if (res && res.Status === 1) {
        let data = res.Result
        localStorage.setItem('roomList', JSON.stringify(data))
        this.setState({
          arr: data
        })
      } else {
        message.error("请检查网络连接")
      }
    });
  }

  initHospitalDept() {  //检查科室
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    let params = {
      Type: "Hospital_Dept",
      hospital_Code: userInfo.HOSPITAL_CODE,
    }
    initHospitalDepts(params).then((res) => {
      if (res && res.Status === 1) {
        this.setState({
          departmentList: res.Result
        })
      }
    });
  }

  getPatientSourceData() {  // 获取患者来源列表
    getPatientSourceList(this.state.params).then(res => {
      if (res && res.Status === 1) {
        this.setState({
          sourceType: res.Result.dataList
        })
      }
    })
  }

  handleExamHospitalDept = (value, option) => { //检查科室
    this.initHospitalRoom(option.props.value)
    this.setState({
      examDeptCode: option.props.value,
      examDeptName: option.props.children,
    })
  }

  initHospitalRoom(value) {
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    let params = {
      Type: "ExamRoomList", // 检查房间
      hospital_uid: userInfo.HOSPITAL_UID,
      DEPT_CODE: value
    }
    initExamRoomList(params).then((res) => {
      if (res && res.Status === 1) {
        this.setState({
          hospitalRoomList: res.Result.ds
        })
      }
    });
  }


  render() {
    const { form: { getFieldDecorator } } = this.props;
    const { tab1Data, tab2Data, tab3Data, tab4Data, hospitalRoomList, departmentList, arrgData, arr, sourceType } = this.state
    return (
      <div className="eleWrap" >
        <Tabs defaultActiveKey="1" type="card" onChange={this.handleActiveKey} className="bookTab">
          <TabPane tab="申请列表" key="1" style={{ width: '76%' }}>
            <Form layout="inline">
              <Form.Item label="拼音">
                <Input />
              </Form.Item>
              <Form.Item label="姓名">
                <Input />
              </Form.Item>
              <Form.Item label="门诊号">
                <Input />
              </Form.Item>
              <Form.Item label="住院号">
                <Input />
              </Form.Item>
              <Form.Item label="申请日期" className="date">
                <DatePicker showTime format="YYYY-MM-DD HH:mm:ss" />
              </Form.Item>
              <Form.Item className="bookQuery">
                <Button>查询</Button>
              </Form.Item>
            </Form>
            <Table
              size="middle"
              style={{ marginTop: '10px' }}
              columns={tab1Column}
              dataSource={tab1Data}
              scroll={{ scrollToFirstRowOnChange: true }}												// 1690 + 申请号
              pagination={false}
              onRow={record => {
                return {
                  onDoubleClick: e => this.applTableRow(record, -3)
                }
              }}
            />
          </TabPane>

          <TabPane tab="待预约列表" key="2" style={{ width: '76%' }}>
            <Form layout="inline" >
              <Form.Item label="拼音">
                {getFieldDecorator('NAME_PHONETIC', { initialValue: "" })(<Input allowClear />,)}
              </Form.Item>
              <Form.Item label="姓名">
                {getFieldDecorator('NAME', { initialValue: "" })(<Input allowClear />,)}
              </Form.Item>

              <Form.Item label="门诊号">
                {getFieldDecorator('OUTP_NO', { initialValue: "" })(<Input allowClear />,)}
              </Form.Item>
              <Form.Item label="住院号">
                {getFieldDecorator('INP_NO', { initialValue: "" })(<Input allowClear />,)}
              </Form.Item>
              <Form.Item label="病历号">
                {getFieldDecorator('PATIENT_ID', { initialValue: "" })(<Input allowClear />,)}
              </Form.Item>
              <Form.Item className="bookQuery">
                <Button type="primary" onClick={this.changeApptQuery}>查询</Button>
              </Form.Item>
            </Form>
            <Table
              size="middle"
              style={{ marginTop: '10px' }}
              columns={tab2Column}
              dataSource={tab2Data}
              rowKey={record => record.EXAM_UID}					// 需要修改为唯一的ID！
              bordered
              onChange={this.handleTableChange}
              scroll={{ x: 380, y: 308, scrollToFirstRowOnChange: true }}
              pagination={{
                showTotal: (count) => {
                  let pageNum = Math.ceil(count / 10);
                  return '共' + pageNum + '页 / ' + count + '条数据';
                }
              }}
              onRow={record => {
                return {
                  onDoubleClick: e => this.apptTableRow(record, -3)
                }
              }}
            />
          </TabPane>

          <TabPane tab="预约列表" key="3" style={{ width: '76%' }}>
            <Form layout="inline" >
              <Form.Item label="首拼">
                {getFieldDecorator('FIRST_SPELL')(<Input allowClear />,)}
              </Form.Item>
              <Form.Item label="姓名">
                {getFieldDecorator('NAME')(<Input allowClear />,)}
              </Form.Item>
              <Form.Item label="检查科室">
                {getFieldDecorator('EXAM_DEPT_NAME', {
                })(
                  <Select allowClear onSelect={this.handleExamHospitalDept} >
                    {departmentList.map((item) => (
                      <Option key={item.DEPT_CODE} value={item.DEPT_CODE}>
                        {item.DEPT_NAME}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="检查房间">
                {getFieldDecorator('EXAM_ROOM', {
                })(
                  <Select allowClear >
                    {hospitalRoomList.map((item) => (
                      <Select.Option key={item.ROOM_NAME} value={item.ROOM_NAME}>
                        {item.ROOM_NAME}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="来源">
                {getFieldDecorator('PATIENT_SOURCE', {
                })(
                  <Select allowClear>
                    {
                      sourceType.map((item) => {
                        return <Option value={item.PATIENT_SOURCE_CODE} key={item.PATIENT_SOURCE_CODE}>{item.PATIENT_SOURCE_NAME}</Option>
                      })
                    }
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="预约日期" className="date">
                {getFieldDecorator('hospDate', {
                  initialValue: [moment(dateFormat.hospDate), moment(dateFormat.hospDate)]
                })(
                  <RangePicker />
                )}
              </Form.Item>
              <Form.Item>
                <Button type="primary" onClick={() => this.handleAppoQuery()}>查询</Button>
              </Form.Item>
            </Form>
            <Table
              size="middle"
              style={{ marginTop: '10px' }}
              columns={tab3Column}
              dataSource={tab3Data}
              rowKey={record => record.EXAM_UID}					// 需要修改为唯一的ID！
              bordered
              scroll={{ x: 380, y: 308, scrollToFirstRowOnChange: true }}
              pagination={{
                showTotal: (count) => {
                  let pageNum = Math.ceil(count / 10);
                  return '共' + pageNum + '页 / ' + count + '条数据';
                }
              }}											// 1690 + 申请号
              onRow={record => {
                return {
                  onDoubleClick: e => this.apptTableRow(record, -2)
                }
              }}
            />
          </TabPane>

          <TabPane tab="登记列表" key="4" style={{ width: '76%' }}>
            <Form layout="inline">
              <Form.Item label="病历号">
                {getFieldDecorator('id')(<Input allowClear />,)}
              </Form.Item>
              <Form.Item label="检查号">
                {getFieldDecorator('check_num')(<Input allowClear />,)}
              </Form.Item>
              <Form.Item label="门诊号">
                {getFieldDecorator('outp')(<Input allowClear />,)}
              </Form.Item>
              <Form.Item label="检查房间">
                {getFieldDecorator('check_room')(
                  <Select allowClear onChange={this.handleRoomGrop}>
                    {arr.map((item) => (
                      <Select.Option key={item.ROOM_NAME} value={item.ROOM_NAME}>
                        {item.ROOM_NAME}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="来源">
                {getFieldDecorator('source', {
                })(
                  <Select allowClear>
                    {
                      sourceType.map((item) => {
                        return <Option value={item.PATIENT_SOURCE_CODE} key={item.PATIENT_SOURCE_CODE}>{item.PATIENT_SOURCE_NAME}</Option>
                      })
                    }
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="登记日期" className="date">
                {getFieldDecorator('firstDate', {
                  initialValue: [moment(dateFormat.firstDate), moment(dateFormat.firstDate)]
                })(
                  <RangePicker disabledDate={this.disabledDate} />
                )}
              </Form.Item>
              <Form.Item>
                <Button type="primary" onClick={this.handleRegQuery}>查询</Button>
              </Form.Item>
            </Form>
            <Table
              size="middle"
              style={{ marginTop: '10px' }}
              columns={tab4Column}
              dataSource={tab4Data}
              rowKey={record => record.EXAM_UID}					// 需要修改为唯一的ID！
              bordered
              scroll={{ x: 380, y: 308, scrollToFirstRowOnChange: true }}
              pagination={{
                showTotal: (count) => {
                  let pageNum = Math.ceil(count / 10);
                  return '共' + pageNum + '页 / ' + count + '条数据';
                }
              }}											// 1690 + 申请号
              onRow={record => {
                return {
                  onDoubleClick: e => this.apptTableRow(record, -1)
                }
              }}
            />
          </TabPane>

          <TabPane tab="排号列表" key="5" style={{ width: '76%' }}>
            <Form layout="inline">
              <Form.Item label="姓名">
                {getFieldDecorator('name')(<Input allowClear />,)}
              </Form.Item>
              <Form.Item label="检查房间">
                {getFieldDecorator('grouping', {
                })(
                  <Select mode="tags" placeholder="请选择检查房间" onChange={this.handleRoomGrop}>
                    {arr.map((item) => (
                      <Select.Option key={item.ROOM_NAME} value={item.ROOM_NAME}>
                        {item.ROOM_NAME}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="申请日期">
                {getFieldDecorator('date', {
                  initialValue: moment(dateFormat.date)
                })(<DatePicker disabledDate={this.disabledDate} />)}
              </Form.Item>
              <Form.Item>
                <Button type="primary" onClick={this.changeAttrQuery}>查询</Button>
              </Form.Item>
            </Form>
            <Table
              size="middle"
              style={{ marginTop: '10px' }}
              columns={this.columns}
              rowKey={record => record.EXAM_UID}					// 需要修改为唯一的ID！
              dataSource={arrgData}
              bordered
              scroll={{ x: 380, y: 308, scrollToFirstRowOnChange: true }}
            />
          </TabPane>
        </Tabs>
      </div>
    )
  }
}


export default (Form.create({})(Classify));